<div class="wf" [class.wf--failed]="run.status === 'failed'">
  <div class="wf__head">
    <span class="wf__name">{{ run.name }}</span>
    <span class="wf__status">{{ statusLine }}</span>
    <button
      *ngIf="run.status === 'running'"
      type="button"
      class="wf__action"
      (click)="cancelled.emit(run.id)"
    >
      cancel
    </button>
  </div>

  <div class="wf__track" role="progressbar" [attr.aria-valuenow]="progressPct" aria-valuemin="0" aria-valuemax="100">
    <div class="wf__fill" [style.width.%]="progressPct"></div>
  </div>

  <ul class="wf__steps">
    <li
      class="wf__step"
      *ngFor="let step of run.steps; trackBy: trackStep"
      [class.wf__step--done]="step.status === 'done'"
      [class.wf__step--running]="step.status === 'running'"
      [class.wf__step--failed]="step.status === 'failed'"
    >
      <button type="button" class="wf__step-row" (click)="toggleStep(step)">
        <span class="wf__step-glyph" aria-hidden="true">{{ glyphFor(step) }}</span>
        <span class="wf__step-label">{{ step.label }}</span>
      </button>
      <div class="wf__step-log" *ngIf="expandedStepId === step.id && step.log.length">
        <p *ngFor="let line of step.log">{{ line }}</p>
      </div>
    </li>
  </ul>

  <!-- Human approval — inline Yes/No, never a dialog. -->
  <div class="wf__approve" *ngIf="run.status === 'awaiting_approval' && run.approval as approval">
    <p class="wf__approve-msg">{{ approval.message }}</p>
    <ul class="wf__approve-items" *ngIf="approval.items?.length">
      <li *ngFor="let item of approval.items">{{ itemLine(item) }}</li>
    </ul>
    <div class="wf__approve-actions">
      <button type="button" class="wf__approve-yes" (click)="decide(true)">{{ approval.confirmLabel }}</button>
      <button type="button" class="wf__approve-no" (click)="decide(false)">{{ approval.cancelLabel }}</button>
    </div>
  </div>

  <!-- Recovery row, not a dialog. -->
  <div class="wf__recover" *ngIf="run.status === 'failed'">
    <span class="wf__error">{{ run.error }}</span>
    <button type="button" class="wf__retry" (click)="retried.emit(run.id)">retry</button>
  </div>
</div>
